import { useOutletContext } from 'react-router-dom'

import { observer } from 'mobx-react'

import VisibilitySection from 'modules/permissions/components/VisibilitySection'

import { PermissionGroupContainerProps } from '../PermissionGroupContainer'

const VisibilityPage = () => {
  const { permissionGroup } = useOutletContext<PermissionGroupContainerProps>()

  return <VisibilitySection permissionGroup={permissionGroup} />
}

export default observer(VisibilityPage)
